import mitt from "mitt";

type Events = {
  "on-message-selected": { timestamp: number };
  "on-message-deselected": { timestamp: number };
  "show-export-modal": void;
  "on-case-selected": { id: string; interuptProgress: boolean };
  "on-case-deleted": { id: string };
  "on-case-export": { id: string };
  "on-llm-home": void;
  "mouse-left-llm": void;
  "llm-interupt": void;
  "close-all": void;
  "open-all": void;
  "opened-sources": { itemID: string };
};
const emitter = mitt<Events>();

export default emitter;
